import { IUserAddOrEditModal } from "../../model/respone/user/IUserAddOrEditModal";
import { apiClient } from "../apiClient";

export const userApi = {
    selectAll: () => apiClient.get(`user`),
    detail: (id: number) => apiClient.get(`user/${id}`),
    insert: (user: IUserAddOrEditModal) => apiClient.post(`user`, user),
    update: (user: IUserAddOrEditModal) => apiClient.put(`user`, user),
    delete: (id: number) => apiClient.delete(`user/${id}`),
    resetPW: (payload: any) => apiClient.put(`user/reset-pw`,payload),
}